import React, { useState } from 'react'
import { getProfile } from '../services/Authentication';
import PageTitle from '../components/PageTitle/PageTitle';
import TableComp from '../components/Table/TableComp';

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    width:"15%"
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
    width:"15%"

  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    width:"15%"
  },
  {
    title: "Message",
    dataIndex: "message",
    key: "message",
    width:"20%"
  },
  {
    title: "Check In / Out",
    dataIndex: "",
    key: "",
    width:"10%"
  },
  // {
  //   title: "Check-Out",
  //   dataIndex: "check-out",
  //   key: "check-out",
  //   width:"10%"
  // },
  {
    title: "Arived At",
    dataIndex: "created_at",
    key: "created_at",
    width:"10%"
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
  },
];

export default function EnquiryList() {
  const [roomData, setRoomData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const { profile } = getProfile();
  const [searchText, setSearchText] = useState("");
  const [total, setTotal] = useState(0);

  return (
    <div>
      <PageTitle
        title="Users"
        icon=""
        buttonText=""
        handleAdd={null}
        isButtonShow={null}
        isShwoButton={true}
        refreshData={null}
        handleListSearch={null}
       
      />
      <div className="px-3">
        <TableComp
          columns={columns}
          dataSource={roomData}
          isDragble={false}
          loading={loading}
          total={total}
          page={page}
          limit={limit}
          setPage={setPage}
        />
      </div>
    </div>
  );
}
